import React from 'react';
import HeroSection from './software/HeroSection';
import AdvantagesSection from './software/AdvantagesSection';
import VisionSection from './software/VisionSection';
import CTASection from './software/CTASection';

const SoftwareDev: React.FC = () => {
  const containerStyle: React.CSSProperties = {
    width: '100%',
    overflowX: 'hidden',
  };

  return (
    <div style={containerStyle}>
      <HeroSection />
      <AdvantagesSection />
      <VisionSection />
      <CTASection />
    </div>
  );
};

export default SoftwareDev; 